<template>
    <modal v-if="modalOpen" :is-card="true" @close="closeModal">
      <template v-slot:body>
          <div class="form-container">
          <h2 class="header">Register Your Interest</h2>          
          <div class="details">
            <div class="form-group-wraper">
              <div class="form-group">
                <input
                  type="text"
                  name="forename"
                  class="form-control"
                  :value="user.forename"
                  data-validate="input"
                  data-validate-message="Please enter your forename"
                  placeholder="Forename*"
                />
              </div>
            </div>
            <div class="form-group-wraper">
              <div class="form-group">
                <input
                  type="text"
                  name="surname"
                  class="form-control"
                  :value="user.surname"
                  data-validate="input"
                  data-validate-message="Please enter your forename"
                  placeholder="surname*"
                />
              </div>
            </div>
            <div class="form-group-wraper">
              <div class="form-group">
                  <select  v-model="user.businessArea" class="form-control">
                      <option value="" disabled selected hidden >Area of interest*</option>
                      <option v-for="(area, value) in business_areas" :key="value" :value="value">{{ area }}</option>
                  </select>
              </div>
          </div>
          <div class="form-group form-group__upload">
                <input
                  type="file"
                  name="cv"
                  class="form-control btn btn-primary"
                  :data-validate-message="!user.cv ? 'You must upload a PDF or Word Document' : ''"
                />
            </div>
          </div>
          <div class="terms">
            <div class="form-group-wraper">
              <div class="radio-area">
                <div class="form-group">
                  <input
                    type="checkbox"
                    name="privacy-policy"
                    data-validate="checkbox"
                    data-error-target="termsError"
                    data-validate-message="You must agree to our terms & conditions"
                    class="careers-checkbox"
                  />
                  <span class="label">
                    I have read and accept the
                    <a class="link link--secondary" :href="privacy_policy_url" target="_blank">Privacy Policy</a>
                    and
                    <a class="link link--secondary" :href="terms_url" target="_blank">Terms and Conditions</a>.
                  </span>
                  <div id="termsError"></div>
                </div>
              </div>
              <!-- Google Recaptcha -->
              <!-- <div class="g-recaptcha mt-4" :data-sitekey="config.recaptcha.key"></div> -->
            </div>
          </div>
          <div class="row">
          <div class="col-sm-3">
            <input type="submit" value="SUBMIT" class="btn btn--primary pull-right" />
          </div>
        </div>
        </div>
      </template>
    </modal>
</template>

<script>
import modal from '../components/Modal.vue';
export default {
    props:[
        'business_areas',
        'privacy_policy_url',
        'terms_url',
        'modalOpen'
    ],
    components: {
        modal,
    },
    data() {
        return {
            user:{
              businessArea: "",
            }
        };
    },
    methods: {
        closeModal() {
            this.$emit('closeModal');
        },
    },
};
</script>


// WEBPACK FOOTER //
// resources/assets/js/careers/components/RegisterInterestModal.vue